export * from './claims-app-settings.config'